// extracted by mini-css-extract-plugin
export default {"container":"ConfirmBulkEmail-ConfirmBulkEmail__container--ximip","successIcon":"ConfirmBulkEmail-ConfirmBulkEmail__successIcon--B3Kxg"};